export const DESKTOP_OS_LIST: string[] = ["Windows", "MacOS", "Linux"];